export enum MarketplaceMode {
    None = "NONE",
    Default = "DEFAULT",
}

export enum ProductStatusId {
    New = 4,
    LikeNew = 1,
    Used = 2,
    NotWorking = 3,
    Unknown = 5,
}

export enum SellTag {
    IsNew = 1,
    ClearanceSale = 2,
    Promo = 4,
    CharlesTip = 8,
    BlackFriday = 16,
    JustDiscounted = 32,
    B2BPromo = 64,
    Universal = 128,
    MegaClearanceSale = 256,
    StoreClean = 512,
    AllFor99CZK = 1024,
    AllFor69CZK = 2048,
    AllFor29CZK = 4096,
    FreeDelivery = 8192,
    Blockbuster = 16_384,
    OneThirdCheaper = 32_768,
    AlmostForHalf = 65_536,
    HotDeals = 131_072,
    FirstMinute = 524_288,
    RepairYourself = 1_048_576,
}

export enum DepartmentId {
    Categorization = 1,
    Photo = 2,
    Testing = 3,
    AddToStore = 4,
    ProductDescription = 5,
    PackageDescription = 6,
    Teamleader = 7,
    Pricing = 8,
    Expedition = 9,
    General = 10,
    Prepackage = 11,
    Shop = 12,
    FBA = 13,
}

export enum MistakeId {
    PrepackageInsufficientPackaging = 105,
    PrepackageInsufficientPackagingInside = 124,
    StoreExpeditionWrongPosition = 132,
    PrepackageRProductInsufficientPackaging = 142,
}
